import {useEffect, useState} from "react";
import cloneDeep from "lodash/cloneDeep";
import useLocalStorageModule from "use-local-storage";
import {toaster} from "../../Components/ui/toaster";
import dataSet from "../../DataSet/dataset.json";
import {getRequestId} from "./getRequestId";
import {CalculatorContext} from "./context";
const useLocalStorage = useLocalStorageModule.default ?? useLocalStorageModule;

export const CalculatorContextProvider = (props) => {
  const {children} = props;
  const [entireData, setEntireData] = useState(dataSet);
  const [selectedData, setSelectedData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [requestId, setRequestId] = useState(0);

  const [selectedDataCache, setSelectedDataCache] = useLocalStorage(
    "selectedDataCache",
    []
  );

  useEffect(() => {
    const generatedRequestId = getRequestId();
    const arr = dataSet.map((item) => ({
      ...item,
      quantity:
        selectedDataCache.find((_item) => item.id === _item.id)?.quantity ||
        item.quantity,
    }));

    setRequestId(generatedRequestId);
    setEntireData(arr);
    setSelectedData(selectedDataCache);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const quantityChangeFunction = (value = 0, id) => {
    const updatedData = [...entireData];
    const index = updatedData.findIndex((item) => item.id === id);
    if (index !== -1) {
      const item = updatedData[index];
      if (item.quantity === 0 && value === 1) {
        toaster.create({
          title: "Added Successfully.",
          description: "New item added to calculator successfully.",
          type: "success",
          duration: 3000,
          closable: true,
        });
      } else if (item.quantity >= 1 && value === 0) {
        toaster.create({
          title: "Removed Successfully.",
          description: "Item removed from the calculator successfully.",
          type: "error",
          duration: 3000,
          closable: true,
        });
      } else if (item.quantity < value || item.quantity > value) {
        toaster.create({
          title: "Quantity Updated",
          description: "Item quantity successfully modified.",
          type: "success",
          duration: 1000,
          closable: true,
        });
      }

      updatedData[index] = {
        ...item,
        quantity: value,
      };

      setEntireData(updatedData);
      const data = cloneDeep(updatedData).filter((item) => item.quantity > 0);
      setSelectedData(data);
      setSelectedDataCache(data);
    }
  };

  const clearProductCart = () => {
    setEntireData(dataSet);
    setSelectedData([]);
  };

  return (
    <CalculatorContext.Provider
      value={{
        clearProductCart,
        entireData,
        quantityChangeFunction,
        requestId,
        selectedData,
        setShowModal,
        showModal,
      }}
    >
      {children}
    </CalculatorContext.Provider>
  );
};
